export var VERSION = '2.11.13';
//# sourceMappingURL=version.js.map